module.exports = __webpack_public_path__ + "img/leiterinnen_evelyne-dober.ea871493.png";